/**Dependecies */
import React from 'react';
import { Row, Col, ListGroup } from "react-bootstrap";

/**Components */

/**Styles */
import '../styles/destinationsList.scss'

/** 
 * Componente para renderizar la lista de destinos y hoteles al hacer clic en el input de búsqueda.
 * Muestra los resultados filtrados basados en la consulta del usuario.
 * 
 * @param {Object} props - Los props del componente.
 * @param {string} props.query - La consulta de búsqueda actual.
 * @param {Array} props.filteredDestinations - Lista de destinos filtrados.
 * @param {Array} props.filteredHotels - Lista de hoteles filtrados.
 * @returns {JSX.Element} - Un componente JSX que muestra la lista de destinos y hoteles.
 */
export const DestinationsList = ({showDestinationList, query, filteredDestinations, filteredHotels, handleSelectItem }) => {
  return (
    <div>
      {showDestinationList && (
        query !== "" && (
          <div className='destinations-container'
            style={{ position: "absolute", left: 0,right: 0, backgroundColor: "#fff", border: "1px solid #ccc",
              borderRadius: "4px",marginTop: "0.5rem", maxHeight: "300px", maxWidth: "400px", overflowY: "auto", zIndex: 1000,
            }}
          >
            <Row className='text-start'>
              {/* Resultados de Destinos */}
              <Col lg={12}>
                <h5 style={{ padding: "0.5rem", borderBottom: "1px solid #ddd" }}>
                  Destinos
                </h5>
                <ListGroup>
                  {filteredDestinations.length > 0 ? (
                    filteredDestinations.map((destino) => (
                      <ListGroup.Item style={{fontSize: "14px"}} key={destino.id} onClick={() => handleSelectItem(destino.id, destino.nombre , "destino")}> {destino.nombre} </ListGroup.Item>
                    ))
                  ) : (
                    <ListGroup.Item>No se encontraron destinos</ListGroup.Item>
                  )}
                </ListGroup>
              </Col>

              {/* Resultados de Hoteles */}
              <Col  lg={12}>
                <h5 style={{ padding: "0.5rem", borderBottom: "1px solid #ddd" }}>
                  Hoteles
                </h5>
                <ListGroup>
                  {filteredHotels.length > 0 ? (
                    filteredHotels.map((hotel) => (
                      <ListGroup.Item style={{fontSize: "14px"}} key={hotel.id_atv3} onClick={() => handleSelectItem(hotel.id_atv3, hotel.nombre , "hotel")}>{hotel.nombre}</ListGroup.Item>
                    ))
                  ) : (
                    <ListGroup.Item>No se encontraron hoteles</ListGroup.Item>
                  )}
                </ListGroup>
              </Col>
            </Row>
          </div>
        )
      )}        
    </div>
  )
}
